export const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

export const validatePassword = (password) => {
    return {
        isValid: password.length >= 8,
        errors: password.length < 8 ? ['Password must be at least 8 characters'] : []
    };
};

export const validateRequired = (value, fieldName) => {
    return {
        isValid: value && value.trim().length > 0,
        error: !value || value.trim().length === 0 ? `${fieldName} is required` : null
    };
};